export const pattern7Data = [
  {
    id: 1,
    koreanChunks: ["회사가", "(과거에)출시했다", "새로운 제품을", "지난달에"],
    englishChunks: ["The company", "launched", "a new product", "last month"],
    fullEnglish: "The company launched a new product last month.",
    explanation:
      "과거 시제 - 특정 과거 시점(last month)에 발생한 사건을 나타냅니다.",
    additionalExplanation:
      '토익몬에서는 과거시제는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 2,
    koreanChunks: ["그녀가", "(과거에)끝냈다", "프로젝트를", "마감 전에"],
    englishChunks: ["She", "completed", "the project", "before the deadline"],
    fullEnglish: "She completed the project before the deadline.",
    explanation: "과거 시제 - 특정 시점(마감) 이전에 완료된 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거시제는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 3,
    koreanChunks: ["그들은", "(과거에)참석했다", "비즈니스 세미나에", "어제"],
    englishChunks: ["They", "attended", "a business seminar", "yesterday"],
    fullEnglish: "They attended a business seminar yesterday.",
    explanation:
      "과거 시제 - 어제 발생한 일을 표현하는 기본적인 과거 시제 문장입니다.",
    additionalExplanation:
      '토익몬에서는 과거시제는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 4,
    koreanChunks: [
      "그는",
      "(과거에)일했다",
      "그 회사에서",
      "5년 동안",
      "퇴사하기 전에",
    ],
    englishChunks: [
      "He",
      "worked",
      "at that company",
      "for five years",
      "before quitting",
    ],
    fullEnglish: "He worked at that company for five years before quitting.",
    explanation:
      "과거 시제 - 과거의 특정 기간(5년) 동안 지속된 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거시제는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 5,
    koreanChunks: ["매니저가", "(과거에)승인했다", "예산 제안을", "지난주에"],
    englishChunks: [
      "The manager",
      "approved",
      "the budget proposal",
      "last week",
    ],
    fullEnglish: "The manager approved the budget proposal last week.",
    explanation: "과거 시제 - 지난주에 발생한 구체적인 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거시제는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 6,
    koreanChunks: [
      "회의가",
      "(과거에)이미 시작되었다",
      "그가 (과거에)도착했을 때",
    ],
    englishChunks: ["The meeting", "had already started", "when he arrived"],
    fullEnglish: "The meeting had already started when he arrived.",
    explanation:
      "과거완료 시제 - 과거의 특정 시점(도착) 이전에 이미 발생한 일을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료시제 had + p.p는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 7,
    koreanChunks: [
      "그녀가",
      "(과거에)완료했다",
      "그 보고서를",
      "고객이 (과거에)요청하기 전에 그 보고서를",
    ],
    englishChunks: [
      "She",
      "had finished",
      "the report",
      "before the client requested it",
    ],
    fullEnglish: "She had finished the report before the client requested it.",
    explanation:
      "과거완료 시제 - 과거의 한 시점(고객의 요청) 이전에 완료된 행동을 나타냅니다.",
    additionalExplanation:
      '토익몬에서는 과거완료시제 had + p.p는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 8,
    koreanChunks: [
      "우리가 (과거에)도착했을 때 공항에",
      "비행기가",
      "(과거에)이륙했었다",
    ],
    englishChunks: [
      "By the time we got to the airport",
      "the plane",
      "had taken off",
    ],
    fullEnglish: "By the time we got to the airport, the plane had taken off.",
    explanation:
      "과거완료 시제 - 과거의 한 시점(공항 도착) 이전에 발생한 사건을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료시제 had + p.p는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 9,
    koreanChunks: [
      "그는",
      "(과거에) 못봤다",
      "그렇게 큰 청중을",
      "그의 발표 전에",
    ],
    englishChunks: [
      "He",
      "had never seen",
      "such a large audience",
      "before his presentation",
    ],
    fullEnglish:
      "He had never seen such a large audience before his presentation.",
    explanation:
      "과거완료 시제 - 과거의 특정 시점(발표) 이전까지의 경험을 부정문으로 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료시제 had + p.p는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 10,
    koreanChunks: [
      "그들은",
      "(과거에)논의했다",
      "그 문제를",
      "결정을 내리기 전에",
    ],
    englishChunks: [
      "They",
      "had discussed",
      "the issue",
      "before making a decision",
    ],
    fullEnglish: "They had discussed the issue before making a decision.",
    explanation:
      "과거완료 시제 - 과거의 한 행동(결정) 이전에 완료된 다른 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료시제 had + p.p는 "(과거에) ~ 했다"로 해석합니다.',
  },
  {
    id: 11,
    koreanChunks: [
      "그는",
      "(과거에)발표하는 중이었다",
      "화재 경보가 (과거에)울렸을 때",
    ],
    englishChunks: [
      "He",
      "was giving a presentation",
      "when the fire alarm rang",
    ],
    fullEnglish: "He was giving a presentation when the fire alarm rang.",
    explanation:
      "과거진행형 - 과거의 특정 시점에 진행 중이던 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거진행형 was/were + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 12,
    koreanChunks: [
      "그녀는",
      "(과거에)진행 중이었다",
      "프로젝트를 ",
      "동료들이 (과거에)참석하고 있는 동안",
      "회의에",
    ],
    englishChunks: [
      "She",
      "was working on ",
      "the project",
      "while her colleagues were attending ",
      "a meeting",
    ],
    fullEnglish:
      "She was working on the project while her colleagues were attending a meeting.",
    explanation:
      "과거진행형 - 과거에 동시에 진행되고 있던 두 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거진행형 was/were + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 13,
    koreanChunks: [
      "그들은",
      "(과거에) 협상 중이었다",
      "계약을",
      "CEO가 (과거에)들어왔을 때",
    ],
    englishChunks: [
      "They",
      "were negotiating",
      "the contract",
      "when the CEO walked in",
    ],
    fullEnglish: "They were negotiating the contract when the CEO walked in.",
    explanation:
      "과거진행형 - 과거의 한 시점에 진행 중이던 행동이 다른 행동으로 인해 중단됨을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거진행형 was/were + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 14,
    koreanChunks: [
      "팀이",
      "(과거에) 논의하는 중이었다",
      "전략을",
      "전화가 (과거에)끊겼을 때",
    ],
    englishChunks: [
      "The team",
      "was discussing",
      "the strategy",
      "when the call disconnected",
    ],
    fullEnglish:
      "The team was discussing the strategy when the call disconnected.",
    explanation:
      "과거진행형 - 과거의 특정 순간에 진행 중이던 회의가 예상치 못한 상황으로 중단됨을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거진행형 was/were + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 15,
    koreanChunks: [
      "나는",
      "(과거에) 검토하는 중이었다",
      "재무 보고서를 ",
      "매니저가 그것을 (과거에)요청했을 때",
    ],
    englishChunks: [
      "I",
      "was reviewing",
      "the financial report",
      "when the manager asked for it",
    ],
    fullEnglish:
      "I was reviewing the financial report when the manager asked for it.",
    explanation:
      "과거진행형 - 과거의 한 시점에 진행 중이던 행동과 그 때 발생한 다른 행동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거진행형 was/were + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 16,
    koreanChunks: [
      "회사가",
      "(현재)제공한다",
      "경쟁력 있는 복리후생을",
      "그회사의 직원들에게",
    ],
    englishChunks: [
      "The company",
      "offers",
      "competitive benefits",
      "to its employees",
    ],
    fullEnglish: "The company offers competitive benefits to its employees.",
    explanation: "현재 시제 - 회사의 일반적인 정책이나 관행을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재시제는 "(현재) ~한다"로 해석합니다.',
  },
  {
    id: 17,
    koreanChunks: [
      "그는",
      "(현재)검토한다",
      "재무 보고서를",
      "매주 월요일마다",
    ],
    englishChunks: ["He", "reviews", "financial reports", "every Monday"],
    fullEnglish: "He reviews financial reports every Monday.",
    explanation: "현재 시제 - 정기적으로 반복되는 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재시제는 "(현재) ~한다"로 해석합니다.',
  },
  {
    id: 18,
    koreanChunks: ["사무실이", "(현재)문을 닫는다", "오후 6시에", "평일에"],
    englishChunks: ["The office", "closes", "at 6 p.m.", "on weekdays"],
    fullEnglish: "The office closes at 6 p.m. on weekdays.",
    explanation: "현재 시제 - 정해진 일상적인 업무 스케줄을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재시제는 "(현재) ~한다"로 해석합니다.',
  },
  {
    id: 19,
    koreanChunks: ["CEO가", "(현재)참석한다", "연례 이사회에"],
    englishChunks: ["The CEO", "attends", "the annual board meeting"],
    fullEnglish: "The CEO attends the annual board meeting.",
    explanation: "현재 시제 - 정기적으로 발생하는 공식적인 행사를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재시제는 "(현재) ~한다"로 해석합니다.',
  },
  {
    id: 20,
    koreanChunks: [
      "고객 서비스팀이",
      "(현재)응답한다",
      "문의에",
      "24시간 이내에",
    ],
    englishChunks: [
      "The customer service team",
      "responds",
      "to inquiries",
      "within 24 hours",
    ],
    fullEnglish:
      "The customer service team responds to inquiries within 24 hours.",
    explanation: "현재 시제 - 회사의 표준 서비스 정책이나 약속을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재시제는 "(현재) ~한다"로 해석합니다.',
  },
  {
    id: 21,
    koreanChunks: [
      "회사가",
      "(현재)확장했다",
      "그 회사의 사업 영역을",
      "유럽으로",
    ],
    englishChunks: [
      "The company",
      "has expanded",
      "its operations",
      "to Europe",
    ],
    fullEnglish: "The company has expanded its operations to Europe.",
    explanation:
      "현재완료 시제 - 과거에 시작되어 현재까지 영향을 미치는 회사의 사업 확장을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료 has/have + p.p는 "(현재) ~했다"로 해석합니다.',
  },
  {
    id: 22,
    koreanChunks: ["그녀는", "(현재)일했다", "마케팅 부서에서", "5년 동안"],
    englishChunks: [
      "She",
      "has worked",
      "in the marketing department",
      "for five years",
    ],
    fullEnglish: "She has worked in the marketing department for five years.",
    explanation:
      "현재완료 시제 - 과거에 시작하여 현재까지 계속되는 근무 경험을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료 has/have + p.p는 "(현재) ~했다"로 해석합니다.',
  },
  {
    id: 23,
    koreanChunks: ["공급업체가", "(현재)배송했다", "모든 자재를", "제시간에"],
    englishChunks: [
      "The supplier",
      "has delivered",
      "all the materials",
      "on time",
    ],
    fullEnglish: "The supplier has delivered all the materials on time.",
    explanation:
      "현재완료 시제 - 최근에 완료된 행동의 결과가 현재와 관련이 있음을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료 has/have + p.p는 "(현재) ~했다"로 해석합니다.',
  },
  {
    id: 24,
    koreanChunks: [
      "우리는",
      "(현재)받았습니다",
      "귀하의 지원서를",
      "그리고 (미래에)검토할 것입니다 그 지원서를 곧",
    ],
    englishChunks: [
      "We",
      "have received",
      "your application",
      "and will review it shortly",
    ],
    fullEnglish:
      "We have received your application and will review it shortly.",
    explanation:
      "현재완료 시제 - 방금 완료된 행동과 이에 따른 향후 계획을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료 has/have + p.p는 "(현재) ~했다"로 해석합니다.',
  },
  {
    id: 25,
    koreanChunks: [
      "그는",
      "(현재)놓치지 않았다",
      "마감일을",
      "회사에 입사한 이후로",
    ],
    englishChunks: [
      "He",
      "has never missed",
      "a deadline",
      "since joining the company",
    ],
    fullEnglish: "He has never missed a deadline since joining the company.",
    explanation:
      "현재완료 시제 - 과거의 특정 시점부터 현재까지의 지속적인 성과를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료 has/have + p.p는 "(현재) ~했다"로 해석합니다.',
  },
  {
    id: 26,
    koreanChunks: [
      "매니저가",
      "(현재)검토하고 있는 중이다",
      "예산 제안을",
      "지금",
    ],
    englishChunks: [
      "The manager",
      "is reviewing",
      "the budget proposal",
      "now",
    ],
    fullEnglish: "The manager is reviewing the budget proposal now.",
    explanation: "현재진행형 - 현재 진행 중인 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재진행형은 "(현재) ~하는 중이다"로 해석합니다.',
  },
  {
    id: 27,
    koreanChunks: ["그들은", "(현재)준비하는 중이다", "다가오는 컨퍼런스를"],
    englishChunks: ["They", "are preparing", "for the upcoming conference"],
    fullEnglish: "They are preparing for the upcoming conference.",
    explanation: "현재진행형 - 현재 진행 중인 준비 과정을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재진행형은 "(현재) ~하는 중이다"로 해석합니다.',
  },
  {
    id: 28,
    koreanChunks: ["그녀는", "(현재)대화 중이다.", "고객과", "지금"],
    englishChunks: ["She", "is speaking", "with a client", "at the moment"],
    fullEnglish: "She is speaking with a client at the moment.",
    explanation:
      "현재진행형 - 현재 진행 중인 비즈니스 미팅이나 대화를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재진행형은 "(현재) ~하는 중이다"로 해석합니다.',
  },
  {
    id: 29,
    koreanChunks: [
      "회사가",
      "(현재)채용 중이다",
      "새로운 직원들을",
      "IT 부서를 위해",
    ],
    englishChunks: [
      "The company",
      "is hiring",
      "new employees",
      "for its IT department",
    ],
    fullEnglish: "The company is hiring new employees for its IT department.",
    explanation: "현재진행형 - 현재 진행 중인 채용 과정을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재진행형은 "(현재) ~하는 중이다"로 해석합니다.',
  },
  {
    id: 30,
    koreanChunks: [
      "그는",
      "(현재)처리하는 중이다",
      "여러 프로젝트들을",
      "동시에",
    ],
    englishChunks: ["He", "is handling", "multiple projects", "simultaneously"],
    fullEnglish: "He is handling multiple projects simultaneously.",
    explanation:
      "현재진행형 - 현재 동시에 진행 중인 여러 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재진행형은 "(현재) ~하는 중이다"로 해석합니다.',
  },
  {
    id: 31,
    koreanChunks: [
      "회사가",
      "(현재) 확장중이었다",
      "시장 점유율을",
      "지난 1년 동안",
    ],
    englishChunks: [
      "The company",
      "has been expanding",
      "its market share",
      "over the past year",
    ],
    fullEnglish:
      "The company has been expanding its market share over the past year.",
    explanation:
      "현재완료진행형 - 과거부터 현재까지 계속 진행되고 있는 회사의 성장을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료진행형은 "(현재) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 32,
    koreanChunks: [
      "그녀는",
      "(현재) 작업중이었다",
      "이 프로젝트에",
      "지난달부터",
    ],
    englishChunks: [
      "She",
      "has been working",
      "on this project",
      "since last month",
    ],
    fullEnglish: "She has been working on this project since last month.",
    explanation:
      "현재완료진행형 - 특정 시점부터 현재까지 계속되고 있는 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료진행형은 "(현재) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 33,
    koreanChunks: ["그들은", "(현재)협상 중이었다", "계약을", "몇 주 동안"],
    englishChunks: [
      "They",
      "have been negotiating",
      "the contract",
      "for several weeks",
    ],
    fullEnglish: "They have been negotiating the contract for several weeks.",
    explanation:
      "현재완료진행형 - 일정 기간 동안 계속되고 있는 비즈니스 협상을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료진행형은 "(현재) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 34,
    koreanChunks: ["그는", "(현재)관리 중이었다", "고객 지원팀을", "3년 동안"],
    englishChunks: [
      "He",
      "has been managing",
      "the customer support team",
      "for three years",
    ],
    fullEnglish:
      "He has been managing the customer support team for three years.",
    explanation:
      "현재완료진행형 - 장기간 지속되고 있는 관리 책임을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료진행형은 "(현재) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 35,
    koreanChunks: [
      "직원들이",
      "(현재)참석 중이었다",
      "교육 세션에",
      "실력 향상을 위해",
    ],
    englishChunks: [
      "The employees",
      "have been attending",
      "training sessions",
      "to improve their skills",
    ],
    fullEnglish:
      "The employees have been attending training sessions to improve their skills.",
    explanation:
      "현재완료진행형 - 지속적인 직원 교육 및 개발 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 현재완료진행형은 "(현재) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 36,
    koreanChunks: [
      "회사가",
      "(과거에)확장 중이었다",
      "사업을",
      "경기 하락 전까지",
    ],
    englishChunks: [
      "The company",
      "had been expanding",
      "its operations",
      "before the economic downturn",
    ],
    fullEnglish:
      "The company had been expanding its operations before the economic downturn.",
    explanation:
      "과거완료진행형 - 과거의 특정 시점(경기 하락) 이전까지 지속되었던 회사의 성장을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료진행형 had been + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 37,
    koreanChunks: [
      "그녀는",
      "(과거에) 일하는 중이었다.",
      "그 프로젝트에",
      "6개월 동안",
      "그것이 (과거에)취소되기 전까지",
    ],
    englishChunks: [
      "She",
      "had been working",
      "on the project",
      "for six months",
      "before it was canceled",
    ],
    fullEnglish:
      "She had been working on the project for six months before it was canceled.",
    explanation:
      "과거완료진행형 - 과거의 특정 시점(취소) 이전까지 지속되었던 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료진행형 had been + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 38,
    koreanChunks: [
      "그들은",
      "(과거에)협상 중이었다",
      "계약을 몇 주 동안",
      "합의에 도달하기 전까지",
    ],
    englishChunks: [
      "They",
      "had been negotiating",
      "the contract for weeks",
      "before reaching an agreement",
    ],
    fullEnglish:
      "They had been negotiating the contract for weeks before reaching an agreement.",
    explanation:
      "과거완료진행형 - 과거의 특정 시점(합의) 이전까지 지속되었던 협상 과정을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료진행형 had been + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 39,
    koreanChunks: [
      "그는",
      "(과거에)관리 중이었다",
      "영업팀을 5년 동안",
      "그가 (과거에)사임하기 전까지",
    ],
    englishChunks: [
      "He",
      "had been managing",
      "the sales team for five years",
      "before he resigned",
    ],
    fullEnglish:
      "He had been managing the sales team for five years before he resigned.",
    explanation:
      "과거완료진행형 - 과거의 특정 시점(사임) 이전까지 지속되었던 관리 역할을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료진행형 had been + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 40,
    koreanChunks: [
      "직원들이",
      "(과거에)참석 중이었다.",
      "교육 세션에",
      "새 시스템이 (과거에) 도입되기 전까지",
    ],
    englishChunks: [
      "The employees",
      "had been attending",
      "training sessions",
      "before the new system was implemented",
    ],
    fullEnglish:
      "The employees had been attending training sessions before the new system was implemented.",
    explanation:
      "과거완료진행형 - 과거의 특정 시점(시스템 도입) 이전까지 지속되었던 교육 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 과거완료진행형 had been + V-ing은 "(과거에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 41,
    koreanChunks: ["CEO가", "(현재)만나는 중이다", "투자자들과", "내일"],
    englishChunks: ["The CEO", "is meeting", "with investors", "tomorrow"],
    fullEnglish: "The CEO is meeting with investors tomorrow.",
    explanation:
      "현재진행 시제의 미래 시제 용법 - 확실히 예정된 가까운 미래의 약속을 표현합니다.",
    additionalExplanation:
      "현재 만나는 중이다'라고 해석하지만 뒤에 '내일(tomorrow)'이라는 미래 시제가 있어 CEO가 지금 만나고 있는 중이 아니라 곧 가까운 미래에 예정된 일임을 표현하려는 것입니다. 영어에서는 확정된 미래 계획을 현재진행형으로 표현하는 것이 일반적입니다.",
  },
  {
    id: 42,
    koreanChunks: [
      "우리는",
      "(현재) 출시 중이다",
      "새로운 제품을",
      "다음 달에",
    ],
    englishChunks: ["We", "are launching", "a new product", "next month"],
    fullEnglish: "We are launching a new product next month.",
    explanation:
      "현재진행형의 미래 시제 용법 - 계획된 제품 출시와 같은 미래의 비즈니스 활동을 표현합니다.",
    additionalExplanation:
      "'현재 출시 중이다'라고 해석했지만 '다음 달에(next month)'라는 미래 표현이 있어 실제로는 확정된 미래 계획을 나타냅니다. 영어에서는 이미 결정되고 확정된 미래 계획을 현재진행형으로 표현하는 것이 자연스럽습니다.",
  },
  {
    id: 43,
    koreanChunks: [
      "그녀는",
      "(현재) 참석 중이다",
      "비즈니스 컨퍼런스에",
      "다음 주에",
    ],
    englishChunks: [
      "She",
      "is attending",
      "a business conference",
      "next week",
    ],
    fullEnglish: "She is attending a business conference next week.",
    explanation:
      "현재진행형의 미래 시제 용법 - 이미 계획된 미래의 행사 참석을 표현합니다.",
    additionalExplanation:
      "'현재 참석 중이다'라고 해석했지만 '다음 주에(next week)'라는 미래 시간 표현이 있어 실제로는 이미 예정된 미래의 일정을 나타냅니다. 이처럼 현재진행형은 단순히 현재 진행 중인 일뿐만 아니라 확정된 미래 계획을 표현할 때도 자주 사용됩니다.",
  },
  {
    id: 44,
    koreanChunks: [
      "그들은",
      "(현재) 이전 중이다",
      "새 사무실로",
      "다음 분기에",
    ],
    englishChunks: ["They", "are moving", "to a new office", "next quarter"],
    fullEnglish: "They are moving to a new office next quarter.",
    explanation:
      "현재진행형의 미래 시제 용법 - 확정된 미래의 사무실 이전 계획을 표현합니다.",
    additionalExplanation:
      "'현재 이전 중이다'라고 해석했지만 '다음 분기에(next quarter)'라는 미래 시간 표현이 있어 실제로는 확정된 미래의 이전 계획을 나타냅니다. 이는 단순 미래(will move)보다 더 확실하게 정해진 계획임을 강조하는 표현입니다.",
  },
  {
    id: 45,
    koreanChunks: [
      "회사가",
      "(현재) 채용 중이다",
      "새 직원들을",
      "다음 주 월요일부터",
    ],
    englishChunks: [
      "The company",
      "is hiring",
      "new employees",
      "starting next Monday",
    ],
    fullEnglish: "The company is hiring new employees starting next Monday.",
    explanation:
      "현재진행형의 미래 시제 용법 - 확정된 미래의 채용 계획을 표현합니다.",
    additionalExplanation:
      "'현재 채용 중이다'라고 해석했지만 '다음 주 월요일부터(starting next Monday)'라는 미래 시간 표현이 있어 실제로는 곧 시작될 확정된 채용 계획을 나타냅니다. 이런 표현은 비즈니스 영어에서 자주 사용되며, 이미 결정되고 준비된 계획임을 강조합니다.",
  },
  {
    id: 46,
    koreanChunks: [
      "회사가",
      "(미래에)출시할 것이다",
      "새로운 제품을",
      "다음 달에",
    ],
    englishChunks: [
      "The company",
      "will launch",
      "a new product",
      "next month",
    ],
    fullEnglish: "The company will launch a new product next month.",
    explanation: "미래 시제 - 회사의 향후 제품 출시 계획을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래시제는 "(미래에) ~할 것이다"로 해석합니다.',
  },
  {
    id: 47,
    koreanChunks: [
      "그는",
      "(미래)참석할 것이다",
      "국제 컨퍼런스에",
      "다음 주에",
    ],
    englishChunks: [
      "He",
      "will attend",
      "the international conference",
      "next week",
    ],
    fullEnglish: "He will attend the international conference next week.",
    explanation: "미래 시제 - 향후 예정된 행사 참석 계획을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래시제는 "(미래에) ~할 것이다"로 해석합니다.',
  },
  {
    id: 48,
    koreanChunks: ["매니저가", "(미래에)검토할 것이다", "제안서를", "내일"],
    englishChunks: ["The manager", "will review", "the proposal", "tomorrow"],
    fullEnglish: "The manager will review the proposal tomorrow.",
    explanation: "미래 시제 - 가까운 미래에 예정된 업무 활동을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래시제는 "(미래에) ~할 것이다"로 해석합니다.',
  },
  {
    id: 49,
    koreanChunks: [
      "우리는",
      "(미래에)알려드릴 것입니다 당신에게",
      "귀하의 지원서가 처리되면",
    ],
    englishChunks: [
      "We",
      "will notify you",
      "once your application is processed",
    ],
    fullEnglish: "We will notify you once your application is processed.",
    explanation: "미래 시제 - 특정 조건이 충족된 후의 후속 조치를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래시제는 "(미래에) ~할 것이다"로 해석합니다.',
  },
  {
    id: 50,
    koreanChunks: ["새로운 정책이", "(미래에)발효될 것이다", "7월 1일부터"],
    englishChunks: ["The new policy", "will take effect", "on July 1st"],
    fullEnglish: "The new policy will take effect on July 1st.",
    explanation: "미래 시제 - 확정된 미래의 정책 변경이나 시행을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래시제는 "(미래에) ~할 것이다"로 해석합니다.',
  },
  {
    id: 51,
    koreanChunks: [
      "내년까지",
      "회사가",
      "(미래에)확장했을 것이다",
      "그회사의 사업을",
      "5개국으로",
    ],
    englishChunks: [
      "By next year",
      "the company",
      "will have expanded",
      "its business",
      " to five countries",
    ],
    fullEnglish:
      "By next year, the company will have expanded its business to five countries.",
    explanation:
      "미래완료 시제 - 미래의 특정 시점(내년)까지 완료될 회사의 사업 확장을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료 시제 will have + p.p는 "(미래에) ~했을 것이다"로 해석합니다.',
  },
  {
    id: 52,
    koreanChunks: [
      "그녀가",
      "(미래에)완료했을 것이다",
      "프로젝트를",
      "마감 전까지",
    ],
    englishChunks: [
      "She",
      "will have completed",
      "the project",
      "before the deadline",
    ],
    fullEnglish: "She will have completed the project before the deadline.",
    explanation:
      "미래완료 시제 - 미래의 특정 시점(마감)까지 완료될 프로젝트를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료 시제 will have + p.p는 "(미래에) ~했을 것이다"로 해석합니다.',
  },
  {
    id: 53,
    koreanChunks: [
      "이번 주 말까지",
      "우리가",
      "(미래에)완료했을 것이다",
      "시장 분석을",
    ],
    englishChunks: [
      "By the end of the week",
      "we",
      "will have finished",
      "the market analysis",
    ],
    fullEnglish:
      "By the end of the week, we will have finished the market analysis.",
    explanation:
      "미래완료 시제 - 미래의 특정 시점(주말)까지 완료될 분석 작업을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료 시제 will have + p.p는 "(미래에) ~했을 것이다"로 해석합니다.',
  },
  {
    id: 54,
    koreanChunks: [
      "계약업체가",
      "(미래에)배송했을 것이다",
      "자재를",
      "공사가 시작될 때까지",
    ],
    englishChunks: [
      "The contractor",
      "will have delivered",
      "the materials",
      "by the time construction begins",
    ],
    fullEnglish:
      "The contractor will have delivered the materials by the time construction begins.",
    explanation:
      "미래완료 시제 - 미래의 특정 사건(공사 시작) 전까지 완료될 배송을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료 시제 will have + p.p는 "(미래에) ~했을 것이다"로 해석합니다.',
  },
  {
    id: 55,
    koreanChunks: [
      "다음 달까지",
      "그가",
      "(미래에)근무했을 것이다",
      "여기서 10년 동안",
    ],
    englishChunks: [
      "By next month",
      "he",
      "will have worked",
      "here for ten years",
    ],
    fullEnglish: "By next month, he will have worked here for ten years.",
    explanation:
      "미래완료 시제 - 미래의 특정 시점(다음 달)까지의 누적 근무 기간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료 시제 will have + p.p는 "(미래에) ~했을 것이다"로 해석합니다.',
  },
  {
    id: 56,
    koreanChunks: ["내일 이 시간에", "CEO가", "(미래에)발표 중일 것이다"],
    englishChunks: [
      "At this time tomorrow",
      "the CEO",
      "will be giving a presentation",
    ],
    fullEnglish:
      "At this time tomorrow, the CEO will be giving a presentation.",
    explanation:
      "미래진행 시제 - 미래의 특정 시점에 진행 중일 발표를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래진행 시제 will be + V-ing는 "(미래에) ~하는 중일 것이다"로 해석합니다.',
  },
  {
    id: 57,
    koreanChunks: [
      "회사가",
      "(미래에)진행 중일 것이다",
      "면접을 ",
      "하루 종일",
    ],
    englishChunks: [
      "The company",
      "will be conducting",
      "interviews",
      "throughout the day",
    ],
    fullEnglish:
      "The company will be conducting interviews throughout the day.",
    explanation:
      "미래진행 시제 - 미래의 특정 기간 동안 계속될 면접 과정을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래진행 시제 will be + V-ing는 "(미래에) ~하는 중일 것이다"로 해석합니다.',
  },
  {
    id: 58,
    koreanChunks: [
      "다음 주 이맘때",
      "그들은",
      "(미래에) 참석 중일 것이다",
      "박람회에",
    ],
    englishChunks: [
      "This time next week",
      "they",
      "will be attending",
      "a trade fair",
    ],
    fullEnglish: "This time next week, they will be attending a trade fair.",
    explanation:
      "미래진행 시제 - 미래의 특정 시점에 진행 중일 박람회 참석을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래진행 시제 will be + V-ing는 "(미래에) ~하는 중일 것이다"로 해석합니다.',
  },
  {
    id: 59,
    koreanChunks: [
      "그는",
      "(미래에)작성 중일 것이다",
      "연간 보고서를 ",
      "오후 내내",
    ],
    englishChunks: [
      "He",
      "will be working on ",
      "the annual report",
      "all afternoon",
    ],
    fullEnglish: "He will be working on the annual report all afternoon.",
    explanation:
      "미래진행 시제 - 미래의 특정 시간 동안 계속될 보고서 작성을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래진행 시제 will be + V-ing는 "(미래에) ~하는 중일 것이다"로 해석합니다.',
  },
  {
    id: 60,
    koreanChunks: [
      "팀이",
      "(미래에) 논의 중일 것이다",
      "예산 제안을",
      "회의에서",
    ],
    englishChunks: [
      "The team",
      "will be discussing",
      "the budget proposal",
      "in the meeting",
    ],
    fullEnglish:
      "The team will be discussing the budget proposal in the meeting.",
    explanation:
      "미래진행 시제 - 미래의 회의에서 진행될 예산 논의를 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래진행 시제 will be + V-ing는 "(미래에) ~하는 중일 것이다"로 해석합니다.',
  },
  {
    id: 61,
    koreanChunks: [
      "내년까지",
      "그녀는",
      "(미래에) 일하고 있는 중이었을 것이다",
      "여기서 5년 동안",
    ],
    englishChunks: [
      "By next year",
      "she",
      "will have been working",
      "here for five years",
    ],
    fullEnglish:
      "By next year, she will have been working here for five years.",
    explanation:
      "미래완료진행 시제 - 미래의 특정 시점까지 계속될 근무 기간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료진행 시제 will have been + V-ing는 "(미래에) ~하는 중이었을 것이다"로 해석합니다.',
  },
  {
    id: 62,
    koreanChunks: [
      "당신이 (현재에)도착할 때",
      "회의가",
      "(미래에)진행 중이었을것이다",
      "1시간 동안",
    ],
    englishChunks: [
      "When you arrive",
      "the meeting",
      "will have been going on",
      "for an hour",
    ],
    fullEnglish:
      "When you arrive, the meeting will have been going on for an hour.",
    explanation:
      "미래완료진행 시제 - 미래의 특정 시점까지 진행되고 있을 회의 시간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료진행형은 "(미래에) ~하는 중이었다"로 해석합니다.',
  },
  {
    id: 63,
    koreanChunks: [
      "이번 달 말까지",
      "회사는",
      "(미래에) 확장 중이었을 것이다.",
      "사업을",
      "2년 동안",
    ],
    englishChunks: [
      "By the end of this month",
      "the company",
      "will have been expanding",
      "its operations",
      "for two years",
    ],
    fullEnglish:
      "By the end of this month, the company will have been expanding its operations for two years.",
    explanation:
      "미래완료진행 시제 - 미래의 특정 시점까지 계속될 회사의 사업 확장 기간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료진행형은 "(미래에) ~하는 중이었을 것이다"로 해석합니다.',
  },
  {
    id: 64,
    koreanChunks: [
      "제품을 출시할 때쯤",
      "우리는",
      "(미래에) 개발 중이었을 것이다",
      "1년이 넘도록",
    ],
    englishChunks: [
      "By the time we launch the product",
      "we",
      "will have been developing it",
      "for over a year",
    ],
    fullEnglish:
      "By the time we launch the product, we will have been developing it for over a year.",
    explanation:
      "미래완료진행 시제 - 미래의 제품 출시 시점까지 계속될 개발 기간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료진행형은 "(미래에) ~하는 중이었을 것이다"로 해석합니다.',
  },
  {
    id: 65,
    koreanChunks: [
      "내년이면",
      "그들은",
      "(미래에)협력 중이었을 것이다",
      "국제 파트너들과 10년 동안",
    ],
    englishChunks: [
      "Next year",
      "they",
      "will have been collaborating",
      "with international partners for a decade",
    ],
    fullEnglish:
      "Next year, they will have been collaborating with international partners for a decade.",
    explanation:
      "미래완료진행 시제 - 미래의 특정 시점까지 지속될 국제 협력 기간을 표현합니다.",
    additionalExplanation:
      '토익몬에서는 미래완료진행형은 "(미래에) ~하는 중이었을 것이다"로 해석합니다.',
  },
  {
    id: 66,
    koreanChunks: [
      "문서들은",
      "(현재) 검토되는 중입니다",
      "법무팀에 의해",
      "지금",
    ],
    englishChunks: [
      "The documents",
      "are being reviewed",
      "by the legal team",
      "now",
    ],
    fullEnglish: "The documents are being reviewed by the legal team now.",
    explanation:
      "현재진행형 수동태 - 현재 진행 중인 문서 검토 과정을 수동태로 표현합니다.",
    additionalExplanation:
      "현재진행형 수동태는 'be동사의 현재형 + being + 과거분사'의 형태로 구성됩니다.",
  },
  {
    id: 67,
    koreanChunks: [
      "방이",
      "(과거에) 청소되는 중이었습니다",
      "손님들이 도착했을 때",
    ],
    englishChunks: ["The room", "was being cleaned", "when the guests arrived"],
    fullEnglish: "The room was being cleaned when the guests arrived.",
    explanation:
      "과거진행형 수동태 - 손님들이 도착한 시점에 진행 중이던 방 청소를 수동태로 표현합니다.",
    additionalExplanation:
      "과거진행형 수동태는 'be동사의 과거형 + being + 과거분사'의 형태로 구성됩니다.",
  },
  {
    id: 68,
    koreanChunks: [
      "새로운 안전 프로토콜이",
      "(현재) 도입되는 중입니다",
      "모든 부서에 걸쳐",
    ],
    englishChunks: [
      "New safety protocols",
      "are being implemented",
      "across all departments",
    ],
    fullEnglish:
      "New safety protocols are being implemented across all departments.",
    explanation:
      "현재진행형 수동태 - 현재 진행 중인 안전 프로토콜 도입 과정을 수동태로 표현합니다.",
    additionalExplanation:
      "현재진행형 수동태는 'be동사의 현재형 + being + 과거분사'의 형태로 구성됩니다.",
  },
  {
    id: 69,
    koreanChunks: [
      "무대가",
      "(미래에) 설치되는 중일 것입니다",
      "손님들이 도착할 때",
    ],
    englishChunks: ["The stage", "will be being set up", "when guests arrive"],
    fullEnglish: "The stage will be being set up when guests arrive.",
    explanation:
      "미래진행형 수동태 - 손님들이 도착할 시점에 진행 중일 무대 설치를 수동태로 표현합니다.",
    additionalExplanation:
      "미래진행형 수동태는 'will + be + being + 과거분사'의 형태로 구성됩니다.",
  },
  {
    id: 70,
    koreanChunks: [
      "여러 불만 사항들이",
      "(현재) 조사되는 중입니다",
      "지원팀에 의해",
    ],
    englishChunks: [
      "Several complaints",
      "are being investigated",
      "by the support team",
    ],
    fullEnglish:
      "Several complaints are being investigated by the support team.",
    explanation:
      "현재진행형 수동태 - 현재 진행 중인 불만 사항 조사를 수동태로 표현합니다.",
    additionalExplanation:
      "현재진행형 수동태는 'be동사의 현재형 + being + 과거분사'의 형태로 구성됩니다.",
  },
];
